export const LANGUAGE_CSHARP = 'C#';
export const LANGUAGE_VB = 'Visual Basic';
export const LANGUAGE_FSHARP = 'F#';
export const LANGUAGE_PHP = 'PHP';
export const LANGUAGE_IL = 'IL';
export const LANGUAGE_DEFAULT = LANGUAGE_CSHARP;